var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "State=Visible"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visible",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99964 13.9998C5.27344 13.9998 2.68932 12.4649 0.319043 9.4377C-0.106348 8.89449 -0.106348 8.10531 0.319043 7.5612C2.68936 4.53461 5.27349 3 7.99964 3C10.7264 3 13.3109 4.53491 15.6811 7.5621C16.1058 8.1055 16.1058 8.8943 15.6811 9.4377C13.3116 12.4649 10.7272 13.9998 7.99964 13.9998ZM7.99964 4.3752C5.69575 4.3752 3.46046 5.73842 1.35585 8.427C1.32586 8.46517 1.32586 8.53552 1.35585 8.5746C3.46069 11.2626 5.69598 12.6255 7.99964 12.6255C10.3035 12.6255 12.5388 11.2623 14.6435 8.5737C14.6742 8.53483 14.6742 8.46405 14.6434 8.4252C12.5393 5.73782 10.304 4.3752 7.99964 4.3752ZM7.99964 11.937C6.16198 11.937 4.66694 10.3951 4.66694 8.4999C4.66694 6.60468 6.16198 5.0628 7.99964 5.0628C9.83779 5.0628 11.3332 6.60468 11.3332 8.4999C11.3332 10.3951 9.83779 11.937 7.99964 11.937ZM7.99964 6.4371C6.89695 6.4371 5.99984 7.36247 5.99984 8.4999C5.99984 9.63733 6.89695 10.5627 7.99964 10.5627C9.10284 10.5627 10.0004 9.63733 10.0004 8.4999C10.0004 7.36247 9.10284 6.4371 7.99964 6.4371Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeVisible);
export default __webpack_public_path__ + "static/media/icon-eye-visible.6d4311a7758b5905ec3c46cd41c7f8b5.svg";
export { ForwardRef as ReactComponent };